import TypedFilters from '../typed-filters'

export default class WpPluginFilters extends TypedFilters {
  static getFilterType() {
    return 'plugin'
  }
}
